import { apiFetch } from '../../api/client';
import { ENDPOINTS } from '../../api/endpoints';

export const fetchIndustries = () => apiFetch(ENDPOINTS.siteCheck.base).then((d) => d.industries || []);
export const startCheck = ({ url }) => apiFetch(ENDPOINTS.siteCheck.base, { method: 'POST', body: { url } });
export const getCheck = (token) => apiFetch(ENDPOINTS.siteCheck.one(token)).then((d) => d.check);
export const unlockCheck = (token, { email, name }) => apiFetch(ENDPOINTS.siteCheck.unlock(token), { method: 'POST', body: { email, name } }).then((d) => d.check);
